import {AUTH } from '../constants';

import { updateObject } from '../utils/utility';

const initialState = {
    isAuth: false,
    isLoading: false,
    isFail: false,
    captchaID: null,
    captchaImage: null,
    error: null
}

const authReducer = (state = initialState, action) => {
    switch(action.type) {
        case AUTH.FETCH_CAPTCHA_LOAD: return fetchCaptchaLoad(state, action);
        case AUTH.FETCH_CAPTCHA_SUCCESS: return fetchCaptchaSuccess(state, action);
        case AUTH.FETCH_CAPTCHA_FAIL: return fetchCaptchaFail(state, action);

        case AUTH.LOGIN_LOAD: return loginLoad(state, action);
        case AUTH.LOGIN_SUCCESS: return loginSuccess(state, action);
        case AUTH.LOGIN_FAIL: return loginFail(state, action);

        case AUTH.LOGOUT: return logout(state, action);
        
        default: return state;
    }
}

const fetchCaptchaLoad = (state, action) => {
    return updateObject(state, {isLoading: true, isFail: false});
}

const fetchCaptchaSuccess = (state, action) => {
    return updateObject(state, {
        isLoading: false, 
        captchaImage: action.captchaImage
    });
}

const fetchCaptchaFail = (state, action) => {
    return updateObject(state, {isLoading: false, isFail: true});
}

const loginLoad = (state, action) => {
    return updateObject(state, {isLoading: true, isFail: false});
}

const loginSuccess = (state, action) => {
    return updateObject(state, {isAuth: true, isLoading: false});
}

const loginFail = (state, action) => {
    return updateObject(state, {
        isLoading: false, 
        isFail: true,
        error: action.error
    });
}

const logout = (state, action) => {
    return updateObject(state, {isAuth: false});
}

export default authReducer;